<template v-cloak>
  <div class="recomend" @click="goshop" v-show="!showlength && shopinfo.shopLogo">
    <div class="left">
      <img v-if="shopinfo" :src="shopinfo.shopLogo" :onerror="befPhoto" alt="">
    </div>
    <div class="center">
      <div class="name">{{shopinfo && shopinfo.shopName}}</div>
      <ul>
        <li>
          <img src="../../../assets/images/emptystar.png" alt="">
          <!-- <img src="../../../assets/images/star.png" alt=""> -->
        </li>
        <li>
          <img src="../../../assets/images/emptystar.png" alt="">
        </li>
        <li>
          <img src="../../../assets/images/emptystar.png" alt="">
        </li>
        <li>
          <img src="../../../assets/images/emptystar.png" alt="">
        </li>
        <li>
          <img src="../../../assets/images/emptystar.png" alt="">
        </li>
      </ul>
    </div>
    <div class="right">进店</div>
  </div>
</template>
<script>
export default {
  props: ["keyword", "showlength"],
  data() {
    return {
      shopinfo: {
        shopLogo: "",
        shopName: "",
        shopLevel: "",
      },
      befPhoto:
        "this.src='https://image10.homedo.com/sitefiles/b2b/Images/Nopic.jpg'", //默认图片
    };
  },
  computed: {
    judgeshow() {
      return $(".coupon-list ul").children().length;
    },
  },
  created() {},
  mounted() {
    var vm = this;
    if (!this.keyword) return;
    $HMD$.Ajax({
      url:
        "https://common-api." +
        $HMD$.rApi.S +
        "homedo.com/bff-common-api/search/getSearchShop?keyword=" +
        this.keyword,
      type: "get",
      dataType: "json",
      success: function (res) {
        if (res.respCode == "0000") {
          vm.shopinfo = res.data || {};
          vm.$nextTick(() => {
            $(".recomend .center ul li").each(function (a) {
              if (vm.shopinfo && a < vm.shopinfo.shopLevel) {
                $(this)
                  .children()
                  .attr(
                    "src",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACsklEQVRIS62VTUhUURTHf+e9N6NmJUGCthCjojZ9LAIrWrRw0cag0ApykZMOJLQwsTYRtipIklxUjGImQYlY0aqgXSGtwkVQQaSZRIWB4kfOvHnvxJuZpskZnRnzLt+79/8795zzv0fIcWmQCtvlvoBafurlFl9yOSq5bNJDWNFttKJcUUXE4LI1RYcM4mQ7nxugmTI7wmNgX0LwtS/KUenj26oAokHqVHmoiuEJiuCKcNIKMfjfAG2hKDrLsCp7UsVEGLHWckA6+bUcJGuKIk2cRun1Al8kpIZBgxXi3ooA2o7BBKW28BxldyYRgZEwHC6eZnKpgiej0jr84fVUmAaVCptFqMRlpwrVKEVLRLkg8AKDtwpjrsPnApMxYFxCzMfqpUGqHKXZjee4BChGKBalUNPTslw2PNicC/OizIjwHqFLIk2MolRm64YV/RfGPUA/yimIt+AqLgehT+YCbPKbdKlyLEOnrJTnAgM+aIkVOQG5q0r1KtzEM+EzSwlID9+TXTTbTJnfpgPlBGCtJHQBW4UHYZO2dXf4EeuiVCFtoNQxue5CPWDmCXEMg34TLkiIyT9n05ysQTbaLq+A7fkABD5YBgdTxdNu4H2YaaC0wGQY2JoPAPjoM9ifFRAJsFcNngqU5wMQ+GoZ1EiIN/88iotFwo3UCvQkXJ0zQ2BKhIDVHZsbyZVWA7uRVuCqgi9n9fhGG6HN383NJQHajt+ZoMOFc5nEBd6pICg7MsKFTp9wUULYGbto6iwbiqP0qXIkRSACjAp0Wwa3ve9RpVmVJoi9Yf6kmDBkCWckxHRGgHqz1+YJShXEBvqIwIDjMlTYy6fUqBeCbDGVWo0bc1fCNy99FrWSMFm60YKscZRrLtSYBjcM4RE/+bbUMNE6TEoojwrHgfPe+2NNcUkG/47R3zVS5W2DbTbPAAAAAElFTkSuQmCC"
                  );
              }
            });
          });
        }
      },
    });
  },
  beforeUpdate() {},
  methods: {
    goshop() {
      // location.href = 'www.baidu.com'
      location.href = this.shopinfo.shopWapUrl;
    },
  },
};
</script>
<style scoped>
.recomend {
  width: 100%;
  height: 70px;
  background: url("../../../assets/images/recomendshopbg.png") no-repeat center
    center / 100% 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.recomend .left {
  width: 45px;
  height: 45px;
  margin-left: 20px;
  margin-right: 12px;
}

.recomend .left img {
  width: 45px;
  display: block;
  border-radius: 50%;
  height: 100%;
}

.recomend .center {
  flex: 1;
}

.recomend .center .name {
  font-weight: 600;
  color: #ffffff;
  font-size: 14px;
  width: 155px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.recomend .center ul {
  display: flex;
  width: 64px;
  height: 16px;
  background-color: #7e7eff;
  border-radius: 8px;
  justify-content: space-evenly;
  padding: 0 5px;
  align-items: center;
  margin-top: 4px auto;
}

.recomend .center ul li {
  display: flex;
  align-items: center;
}

.recomend .center ul img {
  width: 8px;
}
.recomend .right {
  background-color: #fff;
  width: 48px;
  height: 30px;
  margin-right: 20px;
  border-radius: 2px;
  text-align: center;
  line-height: 30px;
  color: #3443fe;
}
</style>